<template>
  <!-- portal chooser start -->
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-12 p-0">
        <div class="login-card login-dark">
          <div>
            <div>
              <a class="logo" href="/">
                <img class="img-fluid for-light m-auto" src="/assets/images/logo.svg" alt="Asher"/>
                <img class="img-fluid for-dark m-auto" src="/assets/images/logo.svg" alt="Asher"/>
              </a>
            </div>
            <div class="login-main wide-main">
              <div class="text-center mb-2">
                <h2 class="mb-1 fw-bold">Welcome to Asher</h2>
                <p class="text-muted mb-0">Choose how you'd like to continue</p>
              </div>

              <div class="row g-4 mt-2">
                <div class="col-12 col-md-6">
                  <a href="/driver/login" class="portal-option d-block text-decoration-none h-100">
                    <div class="card border rounded-4 shadow-sm h-100 text-center px-4 py-5">
                      <div class="portal-icon portal-icon-driver mx-auto mb-4">
                        <i class="fa fa-car-side"></i>
                      </div>
                      <h4 class="fw-bold mb-2">Driver login</h4>
                      <p class="text-muted mb-4">Sign in to your driver account and track your application status.</p>
                      <span class="btn btn-outline-primary rounded-pill px-4 mt-auto align-self-center">
                        Continue as Driver
                        <i class="fa fa-arrow-right ms-2"></i>
                      </span>
                    </div>
                  </a>
                </div>

                <div class="col-12 col-md-6">
                  <a href="/portal/rider" class="portal-option d-block text-decoration-none h-100">
                    <div class="card border rounded-4 shadow-sm h-100 text-center px-4 py-5">
                      <div class="portal-icon portal-icon-rider mx-auto mb-4">
                        <i class="fa fa-user"></i>
                      </div>
                      <h4 class="fw-bold mb-2">Rider login</h4>
                      <p class="text-muted mb-4">Join the waitlist or sign in to track your status.</p>
                      <span class="btn btn-outline-primary rounded-pill px-4 mt-auto align-self-center">
                        Continue as Rider
                        <i class="fa fa-arrow-right ms-2"></i>
                      </span>
                    </div>
                  </a>
                </div>
              </div>

              <p class="text-center text-muted small mt-4 mb-0">
                New to Asher? Selecting an option will guide you through sign up.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.portal-option .card {
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  cursor: pointer;
}

.portal-option:hover .card {
  transform: translateY(-4px);
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.12) !important;
  border-color: var(--bs-primary) !important;
}

.portal-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
}

.portal-icon-driver {
  background: rgba(var(--bs-primary-rgb), 0.12);
  color: var(--bs-primary);
}

.portal-icon-rider {
  background: rgba(var(--bs-primary-rgb), 0.08);
  color: var(--bs-primary);
}
</style>
